import { Serializer } from 'jsonapi-serializer';
import { uuidv7 } from 'uuidv7';

const serializer = new Serializer('NotificationRead', {
	id: 'id',
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['created_at', 'notification', 'user'],
	typeForAttribute: (attr: string) =>
		attr === 'notification' ? 'Notification' : attr === 'user' ? 'User' : attr,
	notification: {
		ref: (record: any) => record.notificationId,
	},
	user: {
		ref: (record: any) => record.userId,
	},
	transform(record: any) {
		return {
			id: record.id ?? uuidv7(),
			...record,
			notification: { id: record.notificationId },
			user: { id: record.userId },
		};
	},
});

export function serializeNotificationReads(read: { userId: string; notificationId: string }) {
	const doc: any = serializer.serialize(read);
	// API adds empty attributes object if only attributes from relationships are present
	if (doc?.data?.attributes && Object.keys(doc.data.attributes).length === 0) {
		delete doc.data.attributes;
	}
	return doc;
}
